import { useState, useEffect } from 'react';

/**
 * Hook that provides current time and updates every minute
 * Used for auto-updating relative timestamps in chat
 */
export const useCurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Update immediately
    setCurrentTime(new Date());
    
    // Set up interval to update every minute
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // 60 seconds

    return () => clearInterval(interval);
  }, []);

  return currentTime;
};

/**
 * Enhanced formatTime function that takes current time into account
 * for real-time relative timestamp updates
 */
export const formatRelativeTime = (timestamp: string, currentTime: Date = new Date()) => {
  const date = new Date(timestamp);
  const diff = currentTime.getTime() - date.getTime();
  
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const years = Math.floor(days / 365);
  
  if (years > 0) return `${years}y`;
  if (days > 0) return `${days}d`;
  if (hours > 0) return `${hours}h`;
  if (minutes > 0) return `${minutes}m`;
  if (seconds > 30) return `${seconds}s`;
  return 'now';
};